<template>
  <div>
    <div v-for="item in data" :key="item.codigo" :class="['card-receitas', gridClass]">
      <div class="row">
        <div class="col-xs-12">
          <router-link v-if="item.hasOwnProperty('link')" :to="item.link">
            <h4 v-if="item.hasOwnProperty('tooltip')"
              :title="item.title"
              :data-content="item.tooltip"
              data-toggle="popover"
              data-placement="auto"
              data-trigger="hover focus"
            >{{ item.title }}</h4>
            <h4 v-else
              :title="item.title"
            >
              {{ item.title }}
            </h4>
          </router-link>

          <h4 v-else :title="item.title" >{{ item.title }}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <p v-for="line in item.data" :key="line.label">
            <strong>{{ line.label }}</strong>: {{ line.value }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [{
          title: 'Título',
          data: [{ label: 'Descrição', value: 'R$ 0,00' }]
        }]
      }
    },
    gridClass: {
      type: String,
      default: 'col-sm-6 col-md-4'
    }
  },
  mounted () {
    window.jQuery('[data-toggle="popover"]').popover({})
  }
}
</script>

<style scoped>
  .card-receitas {
    min-height: 220px;
  }

  .popover {
    color: #697473;
  }
</style>



// WEBPACK FOOTER //
// src/views/public/receitas_despesas/Card.vue